import React from "react";
import ReactDOM from "react-dom/client";
import CustomProducts from "./custom-products";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <CustomProducts />
  </React.StrictMode>,
);
